// extracted by mini-css-extract-plugin
export default {"map-holder":"InvestmentMap_map-holder__u2d5+","map":"InvestmentMap_map__+nBr+","open-map-btn":"InvestmentMap_open-map-btn__mILBJ"};